import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";
import { toastDispatch } from "@/assets/composables/toast-dispatch";

export default {
  namespaced: true,
  state: {
    invoices: [],
    invoice: [],
    recordedPayments:[],
    summary: [],
    paystacklink: null,
    customer_invoice: [],
    url: null,
    customer_history: [],
    total: null,
  },
  mutations: {
    SET_INVOICES(state, data) {
      state.invoices = data;
    },
    SET_INVOICE(state, data) {
      state.invoice = data;
    },
    SET_RECORDED_PAYMENT(state, data) {
      state.recordedPayments = data;
    },
    SET_SUMMARY(state, data) {
      state.summary = data;
    },
    SET_PAYMENTLINK(state, data) {
      state.paystacklink = data;
    },
    SET_CUSTOMER_INVOICE(state, data) {
      state.customer_invoice = data;
    },
    SET_EXPORTURL(state, data) {
      state.url = data;
    },
    SET_CUSTOMER_HISTORY(state, data) {
      state.customer_history = data;
    },
    REMOVE_INVOICES(state, id) {
      let invoiceIndex = state.invoices.data.findIndex(
        (invoice) => invoice.id === id
      );
      state.invoices.data.splice(invoiceIndex, 1);
    },
    SET_TOTALPAGES(state, data) {
      state.total = data;
    },
  },
  actions: {
    async getInvoices({ commit }, params) {
      const headers = apiConfig().headers;
      let result = await API.get(ROUTES().invoices, { params, headers })
        .then((res) => {
          commit("SET_INVOICES", res.data);
          commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async addInvoices({}, payload) {
      let result = await API.post(ROUTES().invoices, payload, apiConfig(true))
        .then((res) => {
          toastDispatch(res, "success");
          router.push({
            name: "invoice-details",
            params: { id: res.data.data.id },
          });
        })
        .catch((err) => {
          console.log(err)
          toastDispatch(err, "error");
        });

      return result;
    },
    async getInvoicesSummary({ commit }) {
      let result = await API.get(ROUTES().invoicesummary, apiConfig()).then(
        (res) => {
          commit("SET_SUMMARY", res.data.data);
        }
      );

      return result;
    },
    async getInvoice({ commit }, id) {
      let result = await API.get(
        `${ROUTES().invoices}/${id}`,
        apiConfig()
      ).then((res) => {
        commit("SET_INVOICE", res.data.data);
      });

      return result;
    },
 
    async getRecordedPayment({ commit }, { id }) {
      const headers = apiConfig().headers;
      const params = { invoice_id: id };
    
      let result = await API.get(`${ROUTES().recordedPayments}`, { headers, params })
        .then((res) => {
          commit("SET_RECORDED_PAYMENT", res.data);
          commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    
      return result;
    }
    
,    
    async getCustomerInvoice({ commit }, { code, notify }) {
      const headers = apiConfig().headers;
      let result = await API.get(ROUTES(code).customerinvoice, {
        params: { notify },
        headers,
      })
        .then((res) => {
          commit("SET_CUSTOMER_INVOICE", res.data.data);
        })
        .catch((err) => {
          router.push({ name: "error-404" });
        });

      return result;
    },
    async exportInvoice({ commit }) {
      let result = await API.post(
        `${ROUTES().invoices}/export`,
        { format: "excel" },
        apiConfig()
      )
        .then((res) => {
          commit("SET_EXPORTURL", res.data.data.url);
          toast.success("Invoices exported successfully");
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },

    async editInvoice({}, { id, payload }) {
      let result = await API.post(
        `${ROUTES().invoices}/${id}/update`,
        payload,
        apiConfig(true)
      )
        .then((res) => {
          toastDispatch(res, "success");
          router.push({
            name: "invoice-details",
            params: { id: res.data.data.id },
          });
        })
        .catch((err) => {
          toastDispatch(err, "error");
        });
      return result;
    },
    async duplicateInvoices({}, id) {
      let result = API.put(
        `${ROUTES().invoices}/${id}/duplicate`,
        {},
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },

    async markAs({}, { id, payload }) {
      let result = API.put(
        `${ROUTES().invoices}/${id}/mark-as`,
        payload,
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async deleteInvoice({ commit }, id) {
      let result = API.delete(`${ROUTES().invoices}/${id}`, apiConfig())
        .then((res) => {
          commit("REMOVE_INVOICES", id);
          toast.success(`${res.data.message}`);
          return true;
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    },
    async sendInvoice({}, id) {
      let result = API.post(`${ROUTES().invoices}/${id}/send`, {}, apiConfig())
        .then((res) => {
          toast.success(res.data.message, {
          });
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async sendReminder({}, id) {
      let result = API.post(
				`${ROUTES().invoices}/${id}/send-reminder`,
				{ channels: ["mail", "sms"] },
				apiConfig()
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
      return result;
    },
    async recordPayment({}, payload) {
      let result = await API.post(ROUTES().invoicepayment, payload, apiConfig())
        .then((res) => {
          toastDispatch(res, "success");
          return result;
        })
        .catch((err) => {
          toastDispatch(err, "error");
        });
    },
    // Make Payment
    async makePayment({ commit }, payload) {
      commit("SET_PAYMENTLINK", null);
      let result = await API.post(ROUTES().customerinvoicepayment, payload)
        .then((res) => {
          toastDispatch(res, "success");
          commit("SET_PAYMENTLINK", res.data.data.link);
        })
        .catch((err) => {
          toastDispatch(err, "error");
        });
      return result;
    },
  },
  getters: {
    invoices(state) {
      return state.invoices;
    },
    recorded_payment(state) {
      return state.recordedPayments;
    },
    invoice(state) {
      return state.invoice;
    },
    summary(state) {
      return state.summary;
    },
    customer_invoice(state) {
      return state.customer_invoice;
    },
    url(state) {
      return state.url;
    },
    paystacklink(state) {
      return state.paystacklink;
    },
    customer_history(state) {
      return state.customer_history;
    },
    total(state) {
      return state.total;
    },
  },
};
